"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FaqSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const faqItems = [{
    question: "Vlad Cotoros Fondator Main Agency",
    answer: "Da, absolut! Acest webinar este conceput tocmai pentru a te ajuta să descoperi oportunități validate de piață. Vei primi 10 idei de afaceri concrete și vei învăța cum să alegi direcția potrivită pentru tine, chiar dacă pornești de la zero."
  }, {
    question: "Lucrez zilnic cu business-uri reale și strategii de marketing aplicate. În acest curs îți arăt exact sistemul pe care îl folosim pentru a atrage clienți online.",
    answer: "Nu, participarea la webinar este complet gratuită. Scopul nostru este să oferim valoare și să te ajutăm să înțelegi potențialul unei afaceri proprii. Totuși, locurile sunt limitate, așa că îți recomandăm să te înscrii cât mai repede."
  }, {
    question: "",
    answer: "Îți recomandăm insistent să participi live pentru a putea pune întrebări și a beneficia de energia sesiunii. De asemenea, doar participanții live pot intra în tombola cu premii. Nu garantăm că va exista o înregistrare disponibilă public ulterior."
  }];
  return <section data-section-id="52092" id="întrebări-și-clarificări" ref={ref} className={`container card my-10 md:my-20 py-10 md:py-20 text-white transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} data-animate={isVisible}>
      <div className="mx-auto max-w-3xl border-l-2 border-primary-500 pl-6 md:pl-10 pr-4 md:pr-6">
        <h2 className="mb-5 font-sans text-2xl font-bold text-primary-500 uppercase tracking-tight !text-left md:text-3xl">TRAINER</h2>

        <Accordion type="single" collapsible className="w-full">
          {faqItems.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-secondary-500 ![padding:0px_0px_8px_0px] !text-xl !font-bold last:border-b-0" style={{
          fontSize: "1.5rem"
        }}>
                {item.question.split(/(Vlad Cotoros|Fondator|Main Agency)/g).map((part, index) => {
            if (part === "Vlad Cotoros") return <span key={index} className="!font-sans !font-bold">Vlad Cotoros</span>;
            if (part === "Fondator") return <span key={index} className="!font-sans !font-thin">Fondator</span>;
            if (part === "Main Agency") return <span key={index} className="!font-sans">Main Agency</span>;
            if (part.includes("Lucrez zilnic")) return <span key={index} className="block mt-2 text-base font-normal text-white/70">{part}</span>;
            return part;
          })}
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}